module.exports = __webpack_public_path__ + "img/pancares-logo.655accc9.svg";